import { useAppSelector } from 'app/hooks';
import Typo from 'consts/typography';
import React from 'react';
import { platformStates } from 'redux/platformSlice';

interface FieldErrorProps {
  message: string;
}

const FieldError: React.FunctionComponent<FieldErrorProps> = ({ message }) => {
  const { isPhone } = useAppSelector(platformStates);

  return <span className={`error-message ${isPhone ? Typo.p8 : Typo.p4}`}>{message}</span>;
};

export default FieldError;
